import { render, staticRenderFns } from "./AddressesWrap.vue?vue&type=template&id=e5871824&"
import script from "./AddressesWrap.vue?vue&type=script&lang=js&"
export * from "./AddressesWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports